import React from "react";
import "./index.scss";
import clsx from "clsx";
import { getPlan } from "config/plans";

interface Props {
  lossPlan: number;
}

const PlanCard: React.FC<Props> = ({ lossPlan }) => {
  const plan = getPlan(lossPlan);
  return (
    <div
      key={plan.title}
      className={clsx("plan-card-component", plan.className)}
    >
      <div className="card-top plan-bgc">
        <div className="plan-bg card-bg-position"></div>
        <div className="card-right">
          {plan.isPro && <div className="card-pro-badge">PRO</div>}
        </div>
      </div>
      <div className="card-description">{plan.description}</div>
      <div className="card-features">
        {plan.features.map((text) => (
          <div key={text} className="card-feature-item">
            <div className="card-feature-item-icon"></div>
            <div className="card-feature-item-text">{text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlanCard;
